export enum ActionType {
  CreateCase = "CreateCase",
  NewRecordEntity = "NewRecordEntity"
}